<template>
    <section class="error">
        <div class="error__inner">
            <h1 ref="heading">404</h1>
            <h2>The page you were looking for doesn't exist!</h2>
            <b-btn :to="{name: 'home'}" variant="primary" class="btn--icon-text"><i class="zmdi zmdi-home"></i>Home</b-btn>
        </div>
    </section>
</template>

<script>
export default {
  name: 'Error404',
  mounted() {
    setTimeout(() => {
      // document.querySelector('#pageLoader').classList.add('fadeOutDown', 'animated');
      this.$refs.heading.classList.add('bounceInDown', 'animated');
    }, 1500);
  },
};
</script>
